import styled, { css } from 'styled-components';
import { always, ifElse, propEq } from 'ramda';

import { COLORS } from '@theme/colors';
import { FONT_SIZE, typography } from '@theme/font';

export const Container = styled.div`
  padding-right: 30px;
`;

const frameStyles = css`
  &:before {
    content: '';
    position: absolute;
    top: 5px;
    left: 5px;
    width: calc(100% - 14px);
    height: calc(100% - 14px);
    border: 2px dashed ${COLORS.BLACK};
  }
`;

const getFrameStyles = ifElse(propEq('withFrame', true), always(frameStyles), always(null));

interface RectangleProps {
  withFrame?: boolean;
  dashed?: boolean;
  width?: number;
  height?: number;
}

const commonLineStyles = css`
  text-align: center;
  position: absolute;
  ${typography({ size: FONT_SIZE.XS })};
  white-space: nowrap;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    left: -1px;
    height: 7px;
    border-left: 1px solid black;
    border-right: 1px solid black;
  }
`;

export const HorizontalLine = styled.div`
  border-top: 1px solid ${COLORS.BLACK};
  width: 100%;
  bottom: -10px;
  left: 0;
  transform: translateY(100%);

  ${commonLineStyles};

  &:before {
    top: -4px;
  }
`;

export const VerticalLine = styled.div`
  border-bottom: 1px solid ${COLORS.BLACK};
  left: calc(100% + 10px);
  top: 0;
  transform: rotate(90deg) translateY(-100%);
  transform-origin: left top;

  ${commonLineStyles};

  &:before {
    bottom: -4px;
  }
`;

export const Rectangle = styled.div<RectangleProps>`
  min-width: 6px;
  width: ${({ width = 100 }) => width}%;
  height: ${({ height }) => height || 0}px;
  border: 2px ${({ dashed }) => (dashed ? 'dashed' : 'solid')} ${COLORS.BLACK};
  position: relative;
  margin-bottom: 50px;

  ${getFrameStyles};

  ${VerticalLine} {
    width: ${({ height = 0 }) => height - 2 || 0}px;
  }
`;

export const RectanglesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const FramedCopy = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
  text-align: center;
  transform: translateY(-50%);
  ${typography({ size: FONT_SIZE.XS })};
`;

export const FramedCopyVertical = styled(FramedCopy)`
  transform: translate(-50%, -50%) rotate(90deg);
  width: 100px;
  left: 50%;
`;
